// Global StemViewer State
import { atom } from "recoil";
import { Socket } from "socket.io-client";

import { CollabState } from "./collab/collab.atom";
import { collabState } from "./collab/collab.selector";
import { genericSelector } from "./helpers/selectors";
import { MarkupState } from "./markup/markup.atom";
import { markupState } from "./markup/markup.selector";
import { stemState, StemState } from "./stem";
import { TrackState } from "./track";
import { trackState } from "./track/track.selector";

export type StemViewerState = {
  stem: StemState;
  track: TrackState;
  markup: MarkupState;
  collab: CollabState;
};

export const socketState = atom<Socket | null>({
  key: "socket",
  default: null,
  dangerouslyAllowMutability: true,
});

export const svState = genericSelector<StemViewerState>("svState", {
  track: trackState,
  stem: stemState,
  markup: markupState,
  collab: collabState,
});
